/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiErrorResponse {
  error: Error
}

export interface BulkImport {
  /** @format int32 */
  id: number
  /** @format date-time */
  createdOn: string
  /** @format int32 */
  tenantId: number
  /** @format int32 */
  ownerProfileId: number
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string
  /** @maxLength 250 */
  payloadUrl?: string | null
  /**
   *
   *
   * 1 = Created
   *
   * 2 = ValidationStarted
   *
   * 3 = Validated
   *
   * 4 = ValidatedWithWarnings
   *
   * 5 = ValidatedWithErrors
   *
   * 6 = Abandoned
   *
   * 7 = ImportStarted
   *
   * 8 = Imported
   *
   * 9 = ImportedWithErrors
   *
   * 10 = ImportedWithWarnings
   *
   * 11 = ImportQueued
   */
  status: ImportStatus
  items: BulkImportItem[]
  results: BulkImportResult[]
  isDeleted: boolean
}

export interface BulkImportItem {
  /** @format uuid */
  id: string
  /** @format date-time */
  createdOn: string
  /**
   * @minLength 1
   * @maxLength 250
   */
  name: string
  /**
   * @minLength 1
   * @maxLength 250
   */
  payloadUrl: string
  /**
   *
   *
   * 1 = Session
   *
   * 2 = Spreadsheet
   */
  type: BulkImportItemType
  /**
   *
   *
   * 1 = Created
   *
   * 2 = ValidationStarted
   *
   * 3 = Validated
   *
   * 4 = ValidatedWithWarnings
   *
   * 5 = ValidatedWithErrors
   *
   * 6 = Abandoned
   *
   * 7 = ImportStarted
   *
   * 8 = Imported
   *
   * 9 = ImportedWithErrors
   *
   * 10 = ImportedWithWarnings
   *
   * 11 = ImportQueued
   */
  status: ImportStatus
  /** @format int32 */
  linkedObjectId?: number | null
  /** @format date-time */
  importedOn?: string | null
  /** @format date-time */
  deletedOn?: string | null
  /** @format int32 */
  bulkImportId: number
  bulkImport: BulkImport
  results: BulkImportItemResult[]
  isDeleted: boolean
}

export interface BulkImportItemResult {
  /** @format int32 */
  id: number
  isDeleted: boolean
  /** @format date-time */
  createdOn?: string | null
  /**
   * @minLength 1
   * @maxLength 250
   */
  message: string
  /**
   *
   *
   * 1 = ValidationWarning
   *
   * 2 = ValidationError
   *
   * 3 = ImportError
   *
   * 4 = ImportWarning
   */
  type: ImportResultType
  /** @format uuid */
  bulkImportItemId: string
  bulkImportItem: BulkImportItem
}

/**
 *
 *
 * 1 = Session
 *
 * 2 = Spreadsheet
 * @format int32
 */
export enum BulkImportItemType {
  Session = 1,
  Spreadsheet = 2,
}

export interface BulkImportResult {
  /** @format int32 */
  id: number
  isDeleted: boolean
  /** @format date-time */
  createdOn?: string | null
  /**
   * @minLength 1
   * @maxLength 250
   */
  message: string
  /**
   *
   *
   * 1 = ValidationWarning
   *
   * 2 = ValidationError
   *
   * 3 = ImportError
   *
   * 4 = ImportWarning
   */
  type: ImportResultType
  /** @format int32 */
  bulkImportId: number
  bulkImport: BulkImport
}

export interface Error {
  /** @format int32 */
  code: number
  /** @minLength 1 */
  message: string
  details?: string | null
}

export interface GetBulkImportResponse {
  /** @format int32 */
  id: number
  isDeleted: boolean
  /** @format date-time */
  createdOn: string
  /** @format int32 */
  tenantId: number
  /** @format int32 */
  ownerProfileId: number
  name: string
  /**
   *
   *
   * 1 = Created
   *
   * 2 = ValidationStarted
   *
   * 3 = Validated
   *
   * 4 = ValidatedWithWarnings
   *
   * 5 = ValidatedWithErrors
   *
   * 6 = Abandoned
   *
   * 7 = ImportStarted
   *
   * 8 = Imported
   *
   * 9 = ImportedWithErrors
   *
   * 10 = ImportedWithWarnings
   *
   * 11 = ImportQueued
   */
  status: ImportStatus
  /** @format int32 */
  countOfItems: number
  results: BulkImportResult[]
}

export interface GetImportByIdPaginatedResponse {
  import: BulkImport
  /** @format int32 */
  totalItemsCount: number
}

export interface GetImportsPaginatedResponse {
  imports: GetBulkImportResponse[]
  /** @format int32 */
  totalCount: number
}

/**
 *
 *
 * 1 = CreatedOn
 * @format int32
 */
export enum GetImportsSortingColumn {
  CreatedOn = 1,
}

/**
 *
 *
 * 1 = ValidationWarning
 *
 * 2 = ValidationError
 *
 * 3 = ImportError
 *
 * 4 = ImportWarning
 * @format int32
 */
export enum ImportResultType {
  ValidationWarning = 1,
  ValidationError = 2,
  ImportError = 3,
  ImportWarning = 4,
}

/**
 *
 *
 * 1 = Created
 *
 * 2 = ValidationStarted
 *
 * 3 = Validated
 *
 * 4 = ValidatedWithWarnings
 *
 * 5 = ValidatedWithErrors
 *
 * 6 = Abandoned
 *
 * 7 = ImportStarted
 *
 * 8 = Imported
 *
 * 9 = ImportedWithErrors
 *
 * 10 = ImportedWithWarnings
 *
 * 11 = ImportQueued
 * @format int32
 */
export enum ImportStatus {
  Created = 1,
  ValidationStarted = 2,
  Validated = 3,
  ValidatedWithWarnings = 4,
  ValidatedWithErrors = 5,
  Abandoned = 6,
  ImportStarted = 7,
  Imported = 8,
  ImportedWithErrors = 9,
  ImportedWithWarnings = 10,
  ImportQueued = 11,
}

/**
 *
 *
 * 1 = asc
 *
 * 2 = desc
 * @format int32
 */
export enum SortingOrder {
  Asc = 1,
  Desc = 2,
}

export interface CreateAsyncPayload {
  /** @format binary */
  File: File
}

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://api-dev.collaborate.center/staging/',
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data)
  }
}

/**
 * @title Import service api
 * @baseUrl https://api-dev.collaborate.center/staging/
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  bulkImports = {
    /**
     * No description
     *
     * @tags BulkImports
     * @name GetPaginatedAsync
     * @request GET:/import-service/api/bulk-imports
     * @secure
     */
    getPaginatedAsync: (
      query?: {
        Search?: string
        /**
         *
         *
         * 1 = CreatedOn
         */
        'SortModel.Column'?: GetImportsSortingColumn
        /**
         *
         *
         * 1 = asc
         *
         * 2 = desc
         */
        'SortModel.Order'?: SortingOrder
        /**
         * @format int32
         * @default 1
         */
        PageNumber?: number
        /**
         * @format int32
         * @default 25
         */
        PageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetImportsPaginatedResponse, any>({
        path: `/import-service/api/bulk-imports`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkImports
     * @name CreateAsync
     * @request POST:/import-service/api/bulk-imports
     * @secure
     */
    createAsync: (data: CreateAsyncPayload, params: RequestParams = {}) =>
      this.http.request<number, ApiErrorResponse>({
        path: `/import-service/api/bulk-imports`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkImports
     * @name GetByIdPaginatedAsync
     * @request GET:/import-service/api/bulk-imports/{id}
     * @secure
     */
    getByIdPaginatedAsync: (
      id: number,
      query?: {
        /**
         * @format int32
         * @default 1
         */
        PageNumber?: number
        /**
         * @format int32
         * @default 25
         */
        PageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetImportByIdPaginatedResponse, ApiErrorResponse>({
        path: `/import-service/api/bulk-imports/${id}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkImports
     * @name StartImportAsync
     * @request POST:/import-service/api/bulk-imports/{id}/start-import
     * @secure
     */
    startImportAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/import-service/api/bulk-imports/${id}/start-import`,
        method: 'POST',
        secure: true,
        ...params,
      }),
  }
  bulkImportsItem = {
    /**
     * No description
     *
     * @tags BulkImportsItem
     * @name IgnoreAsync
     * @request PUT:/import-service/api/bulk-import-items/{id}/ignore
     * @secure
     */
    ignoreAsync: (id: string, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/import-service/api/bulk-import-items/${id}/ignore`,
        method: 'PUT',
        secure: true,
        ...params,
      }),
  }
}
